// Renders the submit button for the contact form, with loading state and icon
import React from 'react';
import { Button } from "@/components/ui/button";
import { useLanguage } from '@/contexts/language/LanguageContext';
import { contactFormCopy } from '@/contexts/language/translations/pages/contactForm';

// Props for the SubmitButton component
interface SubmitButtonProps {
  isSubmitting: boolean; // Whether the form is currently submitting
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting }) => {
  const { language } = useLanguage();
  const c = contactFormCopy[language];
  return (
    <Button 
      type="submit" 
      className="w-full bg-[#FF6B35] hover:bg-[#FF6B35]/90 text-white rounded-lg"
      disabled={isSubmitting}
    >
      {isSubmitting ? (
        // Show a spinner and 'Sending...' text while submitting
        <span className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {c.sending}
        </span>
      ) : (
        // Show the default button text
        <span>{c.submit}</span>
      )}
    </Button>
  );
};

export default SubmitButton;
